import React from 'react';
import { block } from '../../../utils/cn';
const b = block('select-popup');
export const GroupLabel = ({ label }) => {
    return (React.createElement("div", { className: b('group-label') },
        React.createElement("div", { className: b('group-label-content') }, label)));
};
